export default "__VITE_ASSET__e7dc4846__"